import React, { useState, useEffect } from "react";
import { Container, Form, Button, Row, Col, Modal, ListGroup, Accordion, Alert } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/LicenseGoodStanding.css";

const LicenseGoodStanding = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [alertMessage, setAlertMessage] = useState("");

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => { 
    navigate('/edcc-login');
  };
  
  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  const requireLogin = (path) => {
    if (!tokenState) {
      setAlertMessage("Please log in to continue."); // show alert
      setTimeout(() => setAlertMessage(""), 3000); // auto-hide after 3s
    } else {
      navigate(path);
    }
  };  

    const faqData = [
      {
        question:
          "What are the payment options available while applying for AIOTA license Verification/ Certificate for Professional Status?",
        answer: `You can make the payment for AIOTA license Verification via net banking using your credit card/debit card/using your UPI ID; costs Rs 14160 (Including 18% GST).\n
        license Verification payment can be done only through bank transfer:\n
        Account Name: All India Occupational Therapists Association (AIOTA)\n
        Bank Name: Central Bank of India\n
        Branch: Kranti chouk, Chatrapati Sambhajinagar\n
        Account Number: 1026942763\n
        IFSC Code: CBIN0280679\n
        Branch Code: 280679\n
        The amount must be transferred from the applicant's own bank account.`,
      },
      {
        question:
          "Can all the members of AIOTA apply for license Verification/ Certificate for Professional Status?",
        answer: "No, license Verification is given only if you are member of AIOTA for at least past 6 months.",
      },
      {
        question:
          "How many days will it take to complete license Verification?",
        answer:
          "Up to 14 days.",
      },
      {
        question:
            "What is the fee for AIOTA License Verification/ Certificate for Professional Status?",
        answer:
            "Rs 14160 (which is inclusive of 18% GST)",
      },
      {
        question:
            "What is the difference between license Verification and  Certificate for Professional Status?",
        answer:
            `<strong>license Verification</strong> - When AIOTA receives a mail to verify the license of a candidate from an Employer or an Institution or a Regulatory Body(e.g., HCPC, AHPRA), AIOTA would reply to the mail after verifying the following:\n
            If the candidate is a member of AIOTA for at least past six months. [Please note: license Verification is given to the members of AIOTA only if they are a member for at least six months]. if the candidate is not subject to any disciplinary action/termination from AIOTA. if the candidate has completed his/her license Verification from AIOTA.\n
            <strong> Certificate for Professional Status</strong> - On request, AIOTA gives  Certificate for Professional Status to its members after verifying their license. It is given either as hard copy or soft copy (any 1) in response to the email sent. The Certificate will be printed in the AIOTA letterhead and if soft copy is required, the original would be scanned and sent. Based on request,  Certificate for Professional Status will be either sent to the member or the regulatory body they require. The candidate should provide the e-mail address/ postal address where the certificate has to be sent.
            `,
      },
      {
        question:
            "What is the validity for license Verification/ Certificate for Professional Status?",
        answer:
            "6 Months",
      },
      {
        question:
            "What all documents are required for AIOTA license Verification?",
        answer:
            `1) AIOTA Life Membership Certificate copy\n
            2) IOTR Certificate copy`,
      },
      {
        question:
            "What do I do if my payment for AIOTA license Verification has failed or multiple payments have been made?",
        answer:
            "In case your payment is failed or in case of a multiple payment made by mistake, first you have to confirm with your bank. To verify from our end, we require 3-4 working days. In case you have made a double payment, you may contact treasurer@aiota.org to avail the refund.",
      },
      {
        question:
            "What is the official email address for correspondence with respect to matters relating to license verification and  Certificate for Professional Status?",
        answer:
            "Please ensure that you provide admin@aiota.org as the official email address to which the licensing authority may send verification requests. All queries regarding the verification process may please be directed to the same.",
      },
    ];

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container license-good-standing-content-container">
          <section className="license-good-standing-section">
            <Container className="container-license-good-standing">
              <h2 className="text-center license-good-standing-heading mb-5">
                License Verification and  Professional status
              </h2>

              {/* Action Buttons */}
              <Row className="mb-5">
                <Col className="d-flex justify-content-center gap-4">
                  <Button className="w-auto" onClick={() => requireLogin("/license-verification")}>
                    License Verification
                  </Button>
                  <Button className="w-auto" onClick={() => requireLogin("/professional-status")}>
                     Professional status
                  </Button>
                </Col>
              </Row>

            {/* Alert (only visible if message is set) */}
              {alertMessage && (
                <Row className="d-flex justify-content-center">
                    <Alert variant="danger" className="text-center mb-5 alert-license-good">
                    {alertMessage}
                    </Alert>
                </Row>
              )}

              {/* FAQ */}
              <Row className="mb-4">
                <Col>
                  <h4 className="">Frequently Asked Questions</h4>
                  <Accordion className="faq-accordion">
                    {faqData.map((item, index) => (
                      <Accordion.Item
                        eventKey={String(index)}
                        key={index}
                        className="faq-accordion-item"
                      >
                        <Accordion.Header className="faq-accordion-header">
                          {`${item.question}`}
                        </Accordion.Header>
                        <Accordion.Body className="faq-accordion-body ms-5" dangerouslySetInnerHTML={{ __html: item.answer }} />
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default LicenseGoodStanding;